<template>
  <div class="box4-container">
    <div class="title">
      <h3>环境监测</h3>
      <div class="r_block">
        <span></span>
        <em></em>
        <span></span>
      </div>
    </div>
    <div class="content">
      <div class="gas_list">
        <ul>
          <li v-for="(item,index) in gasData.slice(0,8)" :key="index">
            <h3 v-if="index==0||index==2||index==3||index==6" class="yellow">{{item.value}}</h3>
            <h3 v-else-if="index==7" class="red">{{item.value}}</h3>
            <h3 v-else>{{item.value}}</h3>
            <span>{{item.name}}
              <em v-if="item.unit">({{item.unit}})</em>
            </span>
          </li>
        </ul>
      </div>
    </div>
    <div class="bottom">
      <div class="r_block">
        <span></span>
        <em></em>
        <span></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Box4', 
  props: {
    itemData: {
      type: Array,
      required: true,
      default: function () {
        return [

        ]
      }
    },
    lamp_name: {
      type: String,
      required: true,
      default: function () {
        return '默认灯杆1'
      }
    },
  },
  data() {
    return {
      gasData:[
        {
          name: '温度',
          unit: '°C',
          value: 0
        },
        {
          name: '湿度',
          unit: 'RH%',
          value: 0
        },
        {
          name: 'PM2.5',
          unit: 'μg/m3',
          value: 0
        },
        {
          name: 'PM10',
          unit: 'μg/m3',
          value: 0
        },
        {
          name: '光照度',
          unit: 'lux',
          value: 0
        },
        {
          name: '风速',
          unit: 'm/s',
          value: 0
        },
        {
          name: '风向',
          unit: '',
          value: 0
        },
        {
          name: '噪声',
          unit: 'db',
          value: 0
        }
      ]
    }
  },
  watch: {
    itemData: function(newVal){
      if(newVal.length>0){
        this.gasData = newVal;
      }
    }
  },
  methods: {
  }
}
</script>
<style lang='less'>
.box4-container {
  width: 100%;
  height: 100%;
  position: relative;
  .title {
    height:48px;
    display: flex;
    align-items: center;
    justify-content: flex-start ;
    width: 100%;
    background-image: url(../../assets/home_images/title_bg.png);
    background-position: 0 center;
    background-repeat: no-repeat;
    position: relative;
    h3{
      font-size: 20px;
      font-weight: normal;
      color: #fff;
      padding-left: 20px;
      margin:0;
      margin-top:5px;
    }
    .r_block{
      position: absolute;
      right:0;
      bottom:9px;
      display: flex;
      align-items: center;
      span{
        width:3px;
        height:7px;
        background: #a37600;
        display: block;
      }
      em{
        width:12px;
        height:7px;
        background: #0d0707;
        display: block;
      }
    }
  }
  .bottom{
    height:4px;
    display: flex;
    align-items: center;
    justify-content: flex-start ;
    width: 100%;
    background-image: url(../../assets/home_images/con_bot.png);
    background-position: 0 center;
    background-repeat: no-repeat;
    position: absolute;
    bottom: 0;
    left: 0;
    .r_block{
      position: absolute;
      right:0;
      bottom:0px;
      display: flex;
      align-items: center;
      span{
        width:4px;
        height:4px;
        background: #a37600;
        display: block;
      }
      em{
        width:10px;
        height:4px;
        background: #0d0707;
        display: block;
      }
    }
  }
  .content {
    position: absolute;
    top: 48px;
    bottom: 4px;
    left: 0;
    right:0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background-image: url(../../assets/home_images/con_left.png);
    background-position: 0 0;
    background-repeat: no-repeat;
    box-sizing: border-box;
    padding: 5px 20px;
  }
}

.gas_list {
  width: 100%;
  height:100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  ul{
    width: 100%;
    height:100%;
    padding: 0;
    margin: 0;
    list-style: none;
    display: flex;
	  flex-wrap: wrap; 
    li{
      width: 25%; 
      position: relative;
      margin: 0;
      // margin-top:10px;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      h3{
        margin: 0;
        padding: 0;
        width:65px;
        height:65px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-position: center center;
        background-repeat: no-repeat;
        background-image: url(../../assets/home_images/box4/box4_blue.png);
        background-size: 100% 100%;
        font-size: 18px;
        font-weight: normal;
        color: #fff;
        font-family: Bahnschrift, Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;
      }
      h3.yellow{
        background-image: url(../../assets/home_images/box4/box4_yellow.png);
      }
      h3.red{
        background-image: url(../../assets/home_images/box4/box4_red.png);
      }
      span{
        display: block;
        font-size:12px;
        margin:0;
        padding:0;
        margin-top:3px;
        color:#fff;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        em{
          font-style: normal;
        }
      }
    }
    li:last-child{
      h3{
        font-size: 14px;
        font-family: Helvetica Neue,Helvetica,PingFang SC,Hiragino Sans GB,Microsoft YaHei,Arial,sans-serif;;
      }
    }
  }
}
</style>
